import BaseApi from "./BaseApi";

export default class AccessRoles extends BaseApi {
    construct() {}

    static async search(accessId, params = {}) {
        return await AccessRoles.getAxiosInstance().get(AccessRoles.getApiUrl(accessId), {
            params,
        });
    }

    static async list(accessId, params = {}) {
        return await AccessRoles.getAxiosInstance().get(AccessRoles.getApiUrl(accessId) + "/list", {
            params,
        });
    }

    static async create(accessId, params) {
        return await AccessRoles.getAxiosInstance().post(AccessRoles.getApiUrl(accessId), params);
    }

    static async update(accessId, params, id) {
        return await AccessRoles.getAxiosInstance().put(AccessRoles.getApiUrl(accessId) + "/" + id, params);
    }

    static async delete(accessId, id) {
        return await AccessRoles.getAxiosInstance().delete(AccessRoles.getApiUrl(accessId) + "/" + id);
    }

    static async get(accessId, id) {
        return await AccessRoles.getAxiosInstance().get(AccessRoles.getApiUrl(accessId) + "/" + id);
    }

    static getApiUrl(accessId) {
        return BaseApi.getApiUrl() + "admin/apps/" + accessId + "/roles";
    }
}
